import { render, staticRenderFns } from "./estadisticas-articulo-ventas.vue?vue&type=template&id=08f8d372&scoped=true&"
import script from "./estadisticas-articulo-ventas.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-articulo-ventas.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-articulo-ventas.vue?vue&type=style&index=0&id=08f8d372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8d372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VProgressCircular,VRow,VSpacer})
